/**
 * How wet a drawn figure looks for its drip (ADR-144's amendment of 2026-11-01, decision 7): the player's own by its
 * Drenched time left over the effect's duration, or a development page's force; another player's full while its Buffs
 * list names Drenched, which the drip view fades when it ends, since only its owner knows its time left.
 *
 * @param id The figure's id, 0 for the player's own, else its handle.
 * @param drenched The Drenched effect's number.
 * @param own The player's own wetness, 0 to 1.
 * @param buffsOf Another figure's Buffs list by handle, undefined when the page has no state for it.
 * @returns 0 dry to 1 drenched.
 */
export function dripLevelOf(id: number, drenched: number, own: () => number, buffsOf: (handle: number) => readonly number[] | undefined): number {
  if (id === 0) {
    return own();
  }
  const buffs = buffsOf(id);
  return buffs !== undefined && buffs.includes(drenched) ? 1 : 0;
}
